import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { getEnvironment } from '../../../../shared/utils/helpers';

const mutation = graphql`
  mutation DeactivateReleaseMutation($input: DeactivateReleaseInput!) {
    deactivateRelease(input: $input) {
      updatedRelease {
        id
        isActive
      }
    }
  }
`;

const DeactivateReleaseMutation = (id, callback) => {
  const config = {
    mutation,
    variables: { input: { id } },
    onCompleted: response => {
      callback(response.deactivateRelease);
    }
  };

  commitMutation(getEnvironment(), config);
};

export default DeactivateReleaseMutation;
